/**
 * The one width the agent's two screens share (#1294).
 *
 * The start screen draws its heading, pills, composer and suggestions in a
 * column of this width; the chat page draws its sheet at the same width, so the
 * sheet rising out of the bottom edge reads as the column the reader was just
 * looking at, arriving. Two numbers would drift apart on the first change and
 * the arrival would stop landing — hence one constant, imported by both pages.
 */
export const AGENT_COLUMN_MAX_WIDTH = 940
